module.exports = __webpack_public_path__ + "static/img/2179_phase_function_Paper_Points.7381c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2179_phase_function_Paper_Points.png
// module id = ey39
// module chunks = 0